import { FC, useEffect } from "react";
import { useAccount, useDisconnect } from "wagmi";

import { useStoreDispatch, useStoreSelector } from "../../../store/store";
// import { connect } from "../../../utils/Binance/connect";
import { connect } from "../../../utils/Chromia/connect";


const WagmiWrapper: FC = () => {

	const { userAddress } = useStoreSelector(store => store.app);
	const { session } = useStoreSelector(store => store.chromia);
	const { clearAppState, clearChrState, clearModalsState, clearUIstate } = useStoreDispatch();
	const { connector } = useAccount();
	const { disconnect } = useDisconnect();

	useEffect(() => {
		if (userAddress && connector && !session){
			connect(connector);
		}
		// eslint-disable-next-line
	}, [connector, session, userAddress])

	useEffect(() => {
		const changeAccount = () => {
			console.log('account changed');
			window.location.reload()
		}
		const clearState = () => {
			disconnect();
			clearAppState();
			clearChrState();
			clearModalsState();
			clearUIstate();
		}
		if (connector) {
			connector.on('change', changeAccount);
			connector.on('disconnect', clearState);
		}
		return () => {
			connector?.off("change", changeAccount);
			connector?.off('disconnect', clearState);
		}
		// eslint-disable-next-line
	}, [connector])

	/* const getSession = async () => {
		const provider = await (connector?.options?.getProvider? connector?.options?.getProvider() : connector?.getProvider());
		
		const gtx = await getGtxClient();

		if (!provider) throw new Error('missing provider');

		const interactor = await createWeb3ProviderEvmKeyStore(provider).then((keyStore) => { return createKeyStoreInteractor(gtx as IClient, keyStore) })
		console.log('interactor: ', interactor);
		const accs = await interactor.getAccounts();
		console.log('accs: ', accs);
		if (!accs[0]){
			setIsChrRegistered(false);
			return;
		}
		const session = await interactor.getSession(accs[0].id);
		console.log('session: ', session);
		setChrClientAddr(accs[0].id.toString('hex'));
		setSession(session);
		setIsChrRegistered(true);
		// getData();
	} */

	/* async function getData() {
		const promises = await Promise.all([getParams(), getVaults(), getClientInfo(), getPeriods(), updateChromiaBalances()]);
		const [params, vaults, clientInfo, periods, balances] = [...promises]
		dispatchParams(params);
		dispatchVaults(vaults);

		if (periods)
			dispatchPeriods(periods);
		if (clientInfo)
			dispatchClientInfo(clientInfo);
		if (balances)
			dispatchChromiaBalances(balances.data);

		dispatchFtToken()
	} */


	return null;
}

export default WagmiWrapper;